export * from './assignable-compartment.constant';
